/**
 * Briques partagées pour la génération de conclusion (trames Classique et Générateur).
 * Une seule source de vérité pour options, critère "buggy" et cohérence API.
 */

export type ConclusionLength = "court" | "moyen" | "long";

/** Preset ou personnalisé (nombre de mots libre). */
export type ConclusionLengthChoice = ConclusionLength | "custom";

export const CONCLUSION_LENGTH_OPTIONS: readonly ConclusionLength[] = ["court", "moyen", "long"] as const;

export const CONCLUSION_LENGTH_LABELS: Record<ConclusionLength, string> = {
  court: "Court",
  moyen: "Moyen",
  long: "Détaillé",
};

export const CONCLUSION_LENGTH_CUSTOM_LABEL = "Personnalisé";

/** Valeurs par défaut en mots (surchargées par config/prompts.json côté API). */
export const CONCLUSION_LENGTH_WORDS: Record<ConclusionLength, number> = {
  court: 50,
  moyen: 120,
  long: 400,
};

/** Bornes pour la longueur personnalisée (mots). */
export const CONCLUSION_LENGTH_CUSTOM_MIN = 50;
export const CONCLUSION_LENGTH_CUSTOM_MAX = 600;

/**
 * Détecte une réponse conclusion "buggy" (trop courte ou signature seule sans contenu clinique).
 * Utilisée par Classique et Générateur pour la re-tentative automatique.
 */
export function isConclusionBuggy(conclusion: string | null | undefined): boolean {
  if (!conclusion || typeof conclusion !== "string") return true;
  const t = conclusion.trim();
  if (t.length < 120) return true;
  // Code patient au format [XXX-NN] (ex. HUK1-01, ZO5J-01) suivi de la signature sans contenu
  const hasSignatureOnly =
    /\[\w+-\d+\]\s*,?\s*Je me tiens à votre disposition/i.test(t) &&
    /L'orthoptiste/i.test(t) &&
    t.length < 400;
  return hasSignatureOnly;
}
